import React, { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Table from '../../../../components/Table/Table'
import {
    assetEstimateTableCols,
    formatEstimateListTable,
} from '../../../../helpers/tableUtils'
import { getInitialEstimateFilters } from '../../../../helpers/requestsFilters'
import FilterModal from '../../../../components/FilterModal/FilterModal'
import useAuth from '../../../../hooks/useAuth'
import useRequest from '../../../../hooks/useRequest'

const ServiceEstimate = ({
    requests = [],
    loadServiceEstimates,
    assetInfo,
}) => {
    const { locations } = useRequest()
    const { user } = useAuth()
    const locPrefs = user?.locationPreferences
    const allEstimateFilters = getInitialEstimateFilters(locPrefs, locations)

    const [allRequests, setAllRequests] = useState(requests)
    const [filteredEstimates, setFilteredEstimates] = useState([])
    const [hasActiveFilters, setHasActiveFilters] = useState(false)
    const [filterOpen, setFilterOpen] = useState(false)
    const [initialFilters, setInitialFilters] = useState(allEstimateFilters)

    useEffect(() => {
        if (allRequests?.length > 0) {
            setInitialFilters(allEstimateFilters)
        }
    }, [allRequests])

    useEffect(() => {
        if (
            loadServiceEstimates &&
            requests?.length === 0 &&
            assetInfo?.salesforceID != null
        ) {
            loadServiceEstimates()
        }
    }, [assetInfo])

    useEffect(() => {
        setAllRequests(requests)
        setFilteredEstimates(formatEstimateListTable(requests))
        if (requests?.length > 0) {
            setInitialFilters(allEstimateFilters)
        }
    }, [requests])

    const onFilter = filters => {
        let resultList = [...allRequests]
        let hasOneChecked = false
        filters?.forEach(filterG => {
            let matchesResults = []
            let thisFiltersHasResults = false
            filterG?.filters?.forEach(filter => {
                if (filter?.checked) {
                    thisFiltersHasResults = true
                    hasOneChecked = true
                    matchesResults = [
                        ...matchesResults,
                        ...allRequests?.filter(
                            r => r[filterG?.field] === filter?.filterName,
                        ),
                    ]
                }
            })
            if (thisFiltersHasResults) {
                resultList = [...matchesResults]
            } else [(resultList = [...resultList])]
        })

        if (hasOneChecked) {
            setHasActiveFilters(true)
            setFilteredEstimates(formatEstimateListTable(resultList))
        } else {
            setHasActiveFilters(false)
            setFilteredEstimates(formatEstimateListTable(allRequests))
        }
    }

    const renderTable = useCallback(() => {
        return (
            <Table
                selectable={false}
                hasSearch={true}
                columns={assetEstimateTableCols}
                data={filteredEstimates}
                totalResults={requests?.length}
                type="scroll"
                headerTitle="Service Estimate Details"
                searchPlaceholder="Search"
                actions={[
                    <FilterModal
                        key="estimateModal"
                        filtersGroup={initialFilters}
                        open={filterOpen}
                        setOpen={setFilterOpen}
                        onFilter={onFilter}
                        isSmallScreen
                        data={filteredEstimates}
                    />,
                ]}
                searchFields={[
                    'name',
                    'workOrderName',
                    'status',
                    'submittedDate',
                    'validUntil',
                    'estimateDetails',
                    'validUntilPrettyDate',
                    'submittedPrettyDate',
                ]}
                hasActiveFilters={hasActiveFilters}
            />
        )
    })

    return renderTable()
}

ServiceEstimate.propTypes = {
    requests: PropTypes.array,
    loadServiceEstimates: PropTypes.oneOfType([PropTypes.func, PropTypes.any]),
    assetInfo: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
}

export default ServiceEstimate
